import { BorderColorOutlined, CheckCircle } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PolicyFocusDisplayStatusView = function PolicyFocusDisplayStatusView(props) {
  var status = props.status,
      className = props.className;

  var _ref = (props === null || props === void 0 ? void 0 : props.info) || {},
      operationLabel = _ref.operationLabel;

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-col', className),
    children: [operationLabel === 'effective' && /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-row items-center space-x-2 rounded-lg border border-[#1CB258] px-2 py-1 text-[#1CB258]",
      children: [/*#__PURE__*/_jsx(CheckCircle, {
        className: "h-5 w-5"
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle2",
        className: "font-bold",
        children: "Effective"
      })]
    }), operationLabel === 'confirmed' && /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-row items-center space-x-2 rounded-lg border border-dashed border-[#0E35D1] px-2 py-1 text-[#0E35D1]",
      children: [/*#__PURE__*/_jsx(CheckCircle, {
        className: "h-5 w-5"
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle2",
        className: "font-bold",
        children: "Confirmed"
      })]
    }), operationLabel === 'draft' && /*#__PURE__*/_jsxs(Box, {
      className: "flex flex-row items-center space-x-2 rounded-lg border border-dashed border-[#F9AB01] px-2 py-1 text-[#F9AB01]",
      children: [/*#__PURE__*/_jsx(BorderColorOutlined, {
        className: "h-5 w-5"
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle2",
        className: "font-bold",
        children: "Draft"
      })]
    })]
  });
};

export default PolicyFocusDisplayStatusView;